import { connect } from 'react-redux'
import { compose } from 'redux'
import { withTranslator } from '../../components/HOCComponents/withTranslator'
import { withFieldsAvailableAndSelected } from '../../components/HOCComponents/withFieldsAvailableAndSelected'
import PredTech from '../../components/DashboardComponents/PredTech/PredTech'
import { REQUEST_PRED_TECH_DATA_INITIALIZATION, fetchPredTechByLogType, fetchPredTechLayersLog, FETCH_FIELDS_WITH_PRED_TECH_LOGS } from '../../actions/predTech'
import { getFieldsIdsMap, getSelectedFieldsIds } from '../../selectors/fields'

import {
  getSacHa,
  getProdHa,
  getNitro,
  getTchPred,
  getPolPred,
  getIdealParameters,
  getProdphEstimation,
  getAtrEstimation,
  getPolEstimation,
  getSacEstimation,
  getNBunchesEstimation,
  getNitrogenEstimation
} from '../../selectors/predTech'
import { areRequestsLoading, areRequestsSuccessful } from '@layers-frontend/commons/store/selectors/requests'
import { getUiTemporalEvolutionLayout } from '../../selectors/ui'

const mapStateToProps = state => ({
  chartsLayout: getUiTemporalEvolutionLayout(state),
  selectedFieldsIds: getSelectedFieldsIds(state),
  sacHa: getSacHa(state),
  prodHa: getProdHa(state),
  nitro: getNitro(state),
  tchPred: getTchPred(state),
  polPred: getPolPred(state),
  prodphEstimation: getProdphEstimation(state),
  atrEstimation: getAtrEstimation(state),
  polEstimation: getPolEstimation(state),
  sacEstimation: getSacEstimation(state),
  nBunchesEstimation: getNBunchesEstimation(state),
  nitrogenEstimation: getNitrogenEstimation(state),
  idealParameters: getIdealParameters(state),
  isLoading: areRequestsLoading(state, [FETCH_FIELDS_WITH_PRED_TECH_LOGS]),
  fieldsIdsMap: getFieldsIdsMap(state),
  isDataInitialized: areRequestsSuccessful(state, [REQUEST_PRED_TECH_DATA_INITIALIZATION])
})

const mapDispatchToProps = { fetchPredTechByLogType, fetchPredTechLayersLog }

export default compose(withFieldsAvailableAndSelected, withTranslator, connect(mapStateToProps, mapDispatchToProps))(PredTech)
